import gql from 'graphql-tag';

const eligibilityRulesQuery = gql`
  query GetRulesByProductCode($productCode: ID!, $configType: ConfigType!) {
    externalRulesByProductCode(
      productCode: $productCode
      configType: $configType
    ) {
      configId
      categoryCode
      configType
      effectiveFrom
      rules {
        id
        name
        category
        value
        productId
        description
        priority
        actionOnFail
        actionOnNull
        note
      }
    }
  }
`;

export default eligibilityRulesQuery;
